import { useEffect } from "react"
import { highwayNetworkApiSlice } from "../../../../../api/rtk/base/slices/objectTypes/highwayNetworkApiSlice"
import { useDispatch } from "react-redux"
import { showToastMessage } from "../../../../../stateManagement/reducers"

export default function HighwayNetworkSegmentsOverlay() {
    const dispatch = useDispatch()

    const {
        data: highwayNetworkTotals,
        isFetching: fetchingHighwayNetworkTotals,
        isError: isErrorHighwayNetworkTotals
    } = highwayNetworkApiSlice.useFetchHighwayNetworkTotalsQuery({})

    useEffect(() => {
        if (isErrorHighwayNetworkTotals) {
            dispatch(showToastMessage({ messageText: 'Ошибка загрузки протяженности опорной сети', messageType: "error", windowType: "map" }))
        }
    }, [isErrorHighwayNetworkTotals])

    return (
        <div className="map-overlay-highway-network-segment map-overlay">
            <div className="map-overlay-info-block">
                <span className="info-hint-label-field">Опорная сеть:</span>
                {fetchingHighwayNetworkTotals
                    ?
                    <div>
                        <span className="spinner-border spinner-border-sm me-2 ms-2" role="status" aria-hidden="true"></span>
                        <span>Загрузка...</span>
                    </div>
                    :
                    <>
                        {isErrorHighwayNetworkTotals
                            ?
                            <span className="info-hint-label-value">—</span>
                            :
                            <span className="info-hint-label-value">{highwayNetworkTotals?.value[0]?.LengthTotal ? `${highwayNetworkTotals?.value[0]?.LengthTotal} км` : '—'}</span>
                        }
                    </>
                }
            </div>
        </div>
    )
}
